import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { PartenaireEntity } from '../../../../entities/partenaire.entity';
import { ORANGE } from '../../../../shared/colors';
import { createPartenaire } from '../network';

export const PartenaireForm = ({
  setShowDrawer,
  getNewPartenaire,
}: {
  setShowDrawer: (b: boolean) => void;
  getNewPartenaire: (part: PartenaireEntity) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const connectedUser = new ConnectedUserEntity(
    useSelector((state: any) => state.userReducer).user,
  );

  return (
    <div>
      <Form
        layout='vertical'
        style={{ listStyleType: 'none' }}
        form={form}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        initialValues={{
          type: 'Banque',
        }}
        onFinish={async (data) => {
          setIsLoading(true);
          data.manager = connectedUser.manager.url;

          await createPartenaire(data).then(({ data, statusCode }) => {
            if (statusCode?.toString()[0] === '2') {
              notification.success({
                message: 'Succès',
                description: 'Le partenaire a été créé avec succès',
              });
              getNewPartenaire(data);
              setShowDrawer(false);
            } else {
              notification.info({
                message: 'Erreur',
                description: data.message,
              });
            }
            setIsLoading(false);
          });
        }}
      >
        <Form.Item
          label='Nom du partenaire'
          name='nom'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez le nom du partenaire',
            },
          ]}
        >
          <Input placeholder='Entrez le nom du partenaire' />
        </Form.Item>
        <Form.Item
          label='Localisation'
          name='localisation'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez la localisation',
            },
          ]}
        >
          <Input placeholder='Entrez la localisation' />
        </Form.Item>
        <Form.Item
          label='Code référent'
          name='code_referent'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez le code référent',
            },
          ]}
        >
          <Input placeholder='Entrez le code référent' />
        </Form.Item>
        <Form.Item
          label='Type'
          name='type'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez la type de partenaire',
            },
          ]}
          extra={<i>Banque, SVT, Particulier...</i>}
        >
          <Input placeholder='Entrez la type de partenaire' />
        </Form.Item>
        <Form.Item>
          <Button
            type='primary'
            htmlType='submit'
            // size='large'
            loading={isLoading}
            style={{
              width: '50%',
              backgroundColor: ORANGE,
              borderWidth: 0,
              borderRadius: 5,
              marginBottom: 20,
            }}
          >
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
